import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchChatgptConversions } from './chatgptConversionsAPI';

const initialState = {
  status: 'idle',
  error: null,
  weeks: [],
  visitors: [],
  addToCartRate: [],
  purchaseRate: [],
};

export const graphChatgptConversions = createAsyncThunk(
  'chatgptConversions/fetch',
  async (user, { rejectWithValue }) => {
    try {
      const dbpath = `${user}/graph-chatgptConversions`;
      const response = await fetchChatgptConversions(dbpath, user, 'graph-chatgptConversions');
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const chatgptConversionsSlice = createSlice({
  name: 'chatgptConversions',
  initialState,
  reducers: {
    resetChatgptConversions: () => ({ ...initialState }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(graphChatgptConversions.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(graphChatgptConversions.fulfilled, (state, action) => {
        state.status = 'idle';
        state.error = null;
        const result = action.payload;
        try {
          // Backend shape: result[0][0]=visitors, result[0][1]=addToCartRate%, result[0][2]=purchaseRate%
          // result[1] = week labels
          state.visitors      = result[0][0]['data'];
          state.addToCartRate  = result[0][1]['data'];
          state.purchaseRate   = result[0][2]['data'];
          state.weeks          = result[1];
        } catch {
          // Data not yet available from backend — stay silent
        }
      })
      .addCase(graphChatgptConversions.rejected, (state, action) => {
        state.status = 'idle';
        state.error = action.payload?.error;
      });
  },
});

export const { resetChatgptConversions } = chatgptConversionsSlice.actions;

export const selectChatgptVisitors      = (state) => state.chatgptConversions.visitors;
export const selectChatgptAddToCartRate = (state) => state.chatgptConversions.addToCartRate;
export const selectChatgptPurchaseRate  = (state) => state.chatgptConversions.purchaseRate;
export const selectChatgptWeeks         = (state) => state.chatgptConversions.weeks;
export const selectChatgptStatus        = (state) => state.chatgptConversions.status;

export default chatgptConversionsSlice.reducer;
